import styled from "styled-components";
import { theme } from "ui";

export const Countdown = styled.span`
  font-size: ${theme.typography.fontSize.sm.x3};
`;
